import axios from 'axios'
import http from './http'

const auth = {
  signUp: (user, invitation = null, referral = null) => {
    return new Promise((resolve, reject) => {
      const params = {}
      if (invitation) {
        params.invitation = invitation
      }
      if (referral) {
        params.referral = referral
      }
      http.post('/auth/registration/', user, { params: params })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  getAuth: (resource, payload) => {
    return new Promise((resolve, reject) => {
      http.post(resource, payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  getRefreshToken: (token) => {
    return new Promise((resolve, reject) => {
      http.post('/token/refresh/', { refresh: token })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  tokenVerify: (token) => {
    return new Promise((resolve, reject) => {
      http.post('/token/verify/', { token: token })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  bulkInvitation: (persons) => {
    return new Promise((resolve, reject) => {
      http.post('/invitations/send_bulk/', { persons: persons })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  acceptInvitation: (key) => {
    return new Promise((resolve, reject) => {
      http.get(`${key}/accept-invite/`)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  passwordReset: (email) => {
    return new Promise((resolve, reject) => {
      http.post('/auth/password/reset/', { email: email })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  passwordResetConfirm: (payload) => {
    return new Promise((resolve, reject) => {
      http.post('/auth/password/reset/confirm/', {
        uid: payload.uid,
        token: payload.token,
        new_password1: payload.new_password1,
        new_password2: payload.new_password2
      })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getUser: () => {
    return new Promise((resolve, reject) => {
      http.get('/auth/user/')
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  patchUser: (payload) => {
    return new Promise((resolve, reject) => {
      http.patch('/auth/user/', payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  postUserPassword: (payload) => {
    return new Promise((resolve, reject) => {
      http.post('/auth/password/change/', {
        new_password1: payload.new_password1,
        new_password2: payload.new_password2,
        old_password: payload.old_password
      })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  retrieveTrace: () => {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_API_TRACE_URL)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

const general = {
  getList: (resource, query = {}) => {
    return new Promise((resolve, reject) => {
      http.get(`/${resource}/`, { params: query })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  getDetail: (resource, id) => {
    return new Promise((resolve, reject) => {
      http.get(`/${resource}/${id}/`)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  postObject: (resource, payload) => {
    return new Promise((resolve, reject) => {
      http.post(`/${resource}/`, payload)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  }
}

const account = {
  list: (resource, query = {}, responseType = 'json') => {
    return new Promise((resolve, reject) => {
      let request = `/${resource}/`
      http.get(request, { params: query, responseType: responseType })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  retrieve: (resource, id, detail, query = {}) => {
    return new Promise((resolve, reject) => {
      let request = `/${resource}/${id}/`
      if (detail) {
        request += `${detail}/`
      }
      http.get(request, { params: query })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  get: (resource, query = {}) => {
    return new Promise((resolve, reject) => {
      http.get(`/${resource}/`, { params: query })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  create: (resource, payload, detail = null, id = null, query = {}, headers = {}) => {
    return new Promise((resolve, reject) => {
      let request = `/${resource}/`

      if (detail && id) {
        request += `${id}/${detail}/`
      }

      http.post(request, payload, { params: query, headers: headers })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  update: (resource, id, payload, headers = {}) => {
    return new Promise((resolve, reject) => {
      let request = `/${resource}/${id}/`
      http.patch(request, payload, headers)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  destroy: (resource, id, query = {}) => {
    return new Promise((resolve, reject) => {
      http.delete(`/${resource}/${id}/`, { params: query })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getReferralProgram: () => {
    return new Promise((resolve, reject) => {
      http.get('/referrals/program/')
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  patchReferralBeneficiary: (payload) => {
    return new Promise((resolve, reject) => {
      http.patch('/referrals/beneficiary/', payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

export { auth, general, account }
